import { SUPERMERCADOS_CODE } from './../../../../../core/configs/company.config';
import { ConfigUser } from './../../../../../core/configs/user.config';
import {Trip, Constants, DispatchItemToExport} from '../../../../../core';
import { environment } from '../../../../../../environments/environment';
import { pickingSystem } from '../../../../../core/configs/picking.config';

const tripValidations = {
  unpickedTripDispatches: (trip:Trip):boolean=>{
  return !trip.completePercentage || (trip.completePercentage && parseFloat(trip.completePercentage) !== 100);
  },
  tripAlreadyFullyCharged: (trip:Trip):boolean=>{
    return (trip.completePercentageLoaded && parseFloat(trip.completePercentageLoaded) === 100);
  },
  tripEntityIsNotPickingWMS: (trip:Trip, userSession):boolean=>{
    const pickingWMS = `${userSession.entity.company.code}-${pickingSystem.pickingWms.id}`;
    return trip.originPickingSystemCode !== pickingWMS;
  },
  userIsNotSupport: (userSession):boolean=>{
    const userSupport = Constants.ConfigUser.userSupport;
    return !userSession.username.toLowerCase().includes(userSupport.toLowerCase());
  },
  reprintByUserPrinted: (trip: Trip[]): boolean => {
    let isGuidePrinted: boolean = true;
    if (JSON.parse(localStorage.getItem(environment.sessionAuth)).user.entity.company.code === SUPERMERCADOS_CODE) {
      const hasPermission = JSON.parse(localStorage.getItem(environment.sessionAuth)).user.permissions.find(it => it === ConfigUser.PERMISSIONS.REIMPRESION_CARGIO);
      isGuidePrinted = hasPermission || trip.filter(t=> t.carguioState =='No impresa').length === trip.length ? true : false;
    }
    return isGuidePrinted;
  },
  reprintByUserNotPrinted: (trip: Trip[]): boolean => {
    let isGuidePrinted: boolean = false;
    if (JSON.parse(localStorage.getItem(environment.sessionAuth)).user.entity.company.code === SUPERMERCADOS_CODE) {
      const hasPermission = JSON.parse(localStorage.getItem(environment.sessionAuth)).user.permissions.find(it => it === ConfigUser.PERMISSIONS.REIMPRESION_CARGIO);
      let impresos = trip.find(t => t.carguioState == "Impresa" );
      isGuidePrinted = (!hasPermission && impresos) ? true : false;
    }
    return isGuidePrinted;
  }
};



const iconsOfActionsList = [
  {
    icon: 'load-trip',
    tooltip: 'Cargar viaje 100%',
    hasVisibleCondition: (tripList:Trip[]):boolean =>{
      const userSession = JSON.parse(localStorage.getItem(environment.sessionAuth)).user;
      const flagToHideAction = tripList.find(trip=>
        tripValidations.unpickedTripDispatches(trip)
        || tripValidations.tripAlreadyFullyCharged(trip)
        || tripValidations.tripEntityIsNotPickingWMS(trip, userSession)
        || tripValidations.userIsNotSupport(userSession));
      return flagToHideAction? false : true;
    }
  },
  {
    icon: 'printer',
    tooltip: '',
    dropdown: [
      { text: 'Imprimir carguío', value: 'printer' },
      { text: 'Imprimir una guía', value: 'printGuide' }
    ],
    hasVisibleCondition: (trips: Trip[]): boolean => {
      return tripValidations.reprintByUserPrinted(trips);
    }
  },
  {
    icon: 'printer',
    tooltip: '',
    dropdown: [
      { text: 'Imprimir una guía', value: 'printGuide' }
    ],
    hasVisibleCondition: (trips: Trip[]): boolean => {
      return tripValidations.reprintByUserNotPrinted(trips);
    }
  },
  {
    icon: 'cancel',
    tooltip: 'Cancelar viaje'
  },
  {
    icon: 'delivery',
    tooltip: 'Despachar viaje',
    hasVisibleCondition: (element: Trip[]): boolean => {
      const flag = element.find(i => !(i.dispatchable && i.complete));
      return flag ? false : true;
    }
  },
  {
    icon: 'resend',
    tooltip: 'Reenviar a Beetrack',
    hasVisibleCondition: (element: Trip[]): boolean => {
      const flag = element.find(i => i.tripState != Constants.tripStatus.inTransit);
      return flag ? false : true;
    }
  }
];

export const trip = {
  searchText: '',
  dialogHability: true,
  filter: false,
  checkbox: true,
  sort: false,
  export: false,
  paginator: true,
  exportFile: 'viajes.xlsx',
  expandable: false,
  disabled: false,
  partialField: '',
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: Trip) => {
      return row.tripState === Constants.tripStatus.cancelled
        || row.tripState === Constants.tripStatus.finalized;
  },
  columns: [
    {
      title: 'Código de viaje',
      name: 'id',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.id
    },
    {
      title: 'Código de viaje OTM',
      name: 'tripIdOuter',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.tripIdOuter
    },
    {
      title: 'Tipo de viaje',
      name: 'tripType',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.tripType
    },
    {
      title: 'Sucursal de despacho',
      name: 'entityName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.entityName
    },
    {
      title: 'Fecha de entrega',
      name: 'deliveryDate',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.deliveryDate
    },
    {
      title: 'Estado de Guia',
      name: 'guiaState',
      type: 'string',
      editable: false,
      checkAll: false,
      sortServer: true,
      class: 'center',
      value: (element: Trip) => element.guiaState
    },
    /* {
      title: 'Fecha de despacho',
      name: 'deliveryDate',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.deliveryDate
    }, */
    {
      title: 'Fecha de envío programada',
      name: 'plannedDeliveryTripDate',
      sort: false,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.plannedDeliveryTripDate
    },
    {
      title: 'Fecha de envío real',
      name: 'shippingTripDate',
      sort: false,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.shippingTripDate
    },
    {
      title: 'N° placa',
      name: 'plateNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.plateNumber
    },
    {
      title: 'Estado de viaje',
      name: 'tripState',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.tripState
    },
    {
      title: 'Sistema de creación',
      name: 'originTrip',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.originTrip + `${element.chargeNumber ? ' : ' + element.chargeNumber : ''}`
    },
    {
      title: '% Asignados',
      name: 'completePercentage',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.completePercentage + '%'
    },
    {
      title: '% Cargados',
      name: 'completePercentageLoaded',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.completePercentageLoaded + '%'
    },
    {
      title: 'Respuesta de Beetrack',
      name: 'beetrackResponse',
      type: 'button',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => {
        return {
          data: [element.beetrackResponse],
          icon: 'search',
          tooltip: 'Mostrar respuesta de beetrack',
          class: ' recordColumn icon-table',
          disabled: element.beetrackResponse ? false : true
        };
      }
    }
  ]
};

